import { useParams } from "react-router-dom";
import { Fragment } from "react";
import BlogArticle from "../layout/Blog/BlogArticle";
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Loading from "../components/Loading/Loading";
import { Helmet } from "react-helmet-async";
import API_BASE_URL from "../config/api";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function stripHtml(html) {
  return html.replace(/<[^>]*>/g, '');
}

function BlogDetailsPage() {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(false);
  const params = useParams();

  const articleId = params.articleId;

  const fetchArticle = useCallback(async () => {
    setLoading(true);
    try {
      const isUuid = UUID_REGEX.test(articleId);
      const endpoint = isUuid
        ? `${API_BASE_URL}/api/v1/blog/${articleId}`
        : `${API_BASE_URL}/api/v1/blog/slug/${articleId}`;
      const response = await axios.get(endpoint);
      if (response) {
        const post = await response.data;
        if (post) {
          setArticle(post);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
    setLoading(false);
  }, [articleId]);

  useEffect(() => {
    fetchArticle();
  }, [articleId, fetchArticle]);

  return (
    <Fragment>
      {loading && <Loading />}
      {article && (
        <Helmet>
          <title>{article.title} | SoloChat</title>
          <meta name="description" content={stripHtml(article.body).substring(0, 160)} />
          <meta property="og:title" content={article.title} />
          <meta property="og:description" content={stripHtml(article.body).substring(0, 160)} />
          {article.image && <meta property="og:image" content={article.image} />}
          <meta property="og:url" content={`https://solochat-website.web.app/blog/${article.slug || article.id}`} />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="SoloChat" />
          <meta property="article:published_time" content={article.created_at} />
          <meta property="article:author" content={article.author || 'SoloChat'} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={article.title} />
          <meta name="twitter:description" content={stripHtml(article.body).substring(0, 160)} />
          {article.image && <meta name="twitter:image" content={article.image} />}
          <link rel="canonical" href={`https://solochat-website.web.app/blog/${article.slug || article.id}`} />
        </Helmet>
      )}
      {!loading && article && (
        <BlogArticle
          id={article.id}
          title={article.title}
          date={article.created_at}
          author={article.author}
          image={article.image}
          article={article.body}
        />
      )}
    </Fragment>
  );
}

export default BlogDetailsPage;